module.exports = __webpack_public_path__ + "img/1_en.69a42f7b.png";